exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;align-items:center;flex-direction:column;background-color:#fafafa;border-bottom:.15rem solid #f3f2ed}:host .container{display:flex;flex-wrap:wrap;padding-top:2rem;padding-bottom:2rem}:host .container .btn-group{justify-content:flex-end;margin-top:0;width:100%}:host .container .btn-group jhi-button{margin-left:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/search-form/search-form.component.scss
// module id = 680
// module chunks = 0